export const insertGoogleTagManager = (clientId?: string) => {
  if (!clientId) {
    return;
  }
  (function (w: Window, d: Document, l: 'dataLayer', i: string) {
    const head = d.getElementsByTagName('head')[0];
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    const script = d.createElement('script');
    const dl = l !== 'dataLayer' ? `&l=${l}` : '';
    script.defer = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;

    head?.appendChild(script);
  })(window, document, 'dataLayer', clientId);
};
